const emptyValidator = (value, message) => {
  if (message && !value) {
    return message;
  }
  return null;
};

export default emptyValidator;
